import React, { useEffect, useState } from "react";
import data from './data.json';
import TopSectionComponent from '../../components/TopSectionComponent/TopSectionComponent.tsx';
import { useTranslation } from "react-i18next";
import GetInTouchComponent from "../../components/GetInTouchComponent/GetInTouchComponent.tsx";
import { useParams } from "react-router-dom";
import { useCustomNavigation } from "../../utility/Utility.ts";
import { urlEndPoints } from "../../constants/constants.ts";
import IconCardComponent from "../../components/IconCardComponent/IconCardComponent.tsx";
import JoinMovementComponent from "../../components/JoinMovementComponent/JoinMovementComponent.tsx";

const ServicePage = () => {
    const { ServiceList } = data;
    const {t} = useTranslation();
    const {serviceName: serviceUrlEndpoint} = useParams();
    const [currentService, setCurrentService] = useState(ServiceList.__dummy);
    const customNavigate = useCustomNavigation();

    const handleSetCurrentService = () => {
        for( let key in urlEndPoints.Service){
            if(urlEndPoints.Service[key] === serviceUrlEndpoint){
                const currentServiceData = ServiceList[key];

                if(currentServiceData){
                    setCurrentService(currentServiceData);
                } else {
                    customNavigate(true, '/');
                }
            }
        }
    };

    useEffect(() => {
        handleSetCurrentService();
    },[serviceUrlEndpoint]);

    return (
        <div>
            <>
            {
                (currentService.sect1) &&
                (<TopSectionComponent
                    title={currentService.sect1.title}
                    topText={currentService.sect1.topText}
                    topTextIcon={'☺️'}
                    text={currentService.sect1.text}
                    buttons={[]}
                />)
            }
            </>
            <>
            {
                (currentService.sect2) &&
                (<div className="section bg-light-gray-E9E">
                    <div className="grid gap-8 lg:gap-16">
                        <div className="flex flex-wrap justify-between gap-6 md:flex-nowrap lg:gap-16">
                            <p className="text-3xl font-bold text-black-1A1 lg:text-4xl lg:max-w-[30rem]">{t(currentService.sect2.title)}</p>
                            <p className="text-base font-normal text-gray-535 lg:max-w-[30rem]">{t(currentService.sect2.paragraph)}</p>
                        </div>
                        <img loading="lazy" src={currentService.sect2.image.img} alt=""
                            className={`w-full h-[26.75rem] rounded-lg bg-gray-DDE ${currentService.sect2.image.class}`}
                        />
                    </div>
                </div>)
            }
            </>
            <>
            {
                (currentService.sect3) &&
                (<div className="section">
                    <div className="grid gap-16">
                        <div className="flex flex-col gap-8 text-center">
                            <p className="text-3xl font-semibold text-black-1A1">{t('COMMON.KEY_FEATURES')}</p>
                            <>
                            {
                                (currentService.sect3.paragraph) &&
                                <p className="text-base font-normal text-gray-535 max-w-[48rem] m-auto lg:text-xl">{t(currentService.sect3.paragraph)}</p>
                            }
                            </>
                        </div>

                        <div className="flex flex-col gap-8 xl:grid xl:grid-cols-[32.5rem,1fr]">
                            <div
                                className="relative bg-cover w-full h-[23.125rem] rounded-md xl:h-full xl:rounded-lg bg-gray-DDE"
                                style={{ backgroundImage: `url('${currentService.sect3.img}')` }}
                            ></div>
                            <div className="grid">
                                {
                                    currentService.sect3.list.map((item, index: number) => (
                                        <div key={`${serviceUrlEndpoint}-sect-3-${index}`}
                                            className={`grid grid-cols-[auto,1fr] gap-x-5 gap-y-4 py-6 border-gray-E9E ${index > 0 ? 'border-t' : 'border-t-0 pt-0'} xl:grid-cols-[auto,17rem,1fr] xl:gap-5`}
                                            >
                                            <div>
                                                <p className="text-base font-medium text-gray-414 leading-none border-2 border-gray-E9E rounded-xl p-3">{(index + 1).toString().padStart(2,'0')}</p>
                                            </div>
                                            <p className="text-lg font-semibold text-black-252 pt-3 xl:text-xl">{t(item.title)}</p>
                                            <div className={`block xl:hidden`}>{/* Using this div for spacing and alignment bugfix purposes. */}</div>
                                            <p className="text-sm font-medium text-gray-535 xl:text-base xl:pt-3">{t(item.paragraph)}</p>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                </div>)
            }
            </>
            <>
            {
                (currentService.sect5) &&
                (<div className="section">
                    <div className="flex flex-col gap-8 lg:gap-16">
                        <div className="flex flex-col gap-5">
                            <p className="text-3xl font-semibold text-black-1A1 lg:text-4xl">{t(currentService.sect5.title)}</p>
                            <>
                            {
                                (currentService.sect5.paragraph) &&
                                <p className="text-base font-normal text-gray-535 lg:text-xl lg:max-w-[40rem]">{t(currentService.sect5.paragraph)}</p>
                            }
                            </>
                        </div>
                        <div className="grid gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
                            {
                                currentService.sect5.list.map((item, index: number) => (
                                    <React.Fragment key={`${serviceUrlEndpoint}-sect-5-${index}`}>
                                        <IconCardComponent
                                            img={item.img}
                                            imgContainerClass={'bg-blue-1F3 text-white'}
                                            title={item.title}
                                            titleClass={'text-black-1A1'}
                                            paragraph={item.paragraph}
                                            paragraphClass={'text-gray-535'}
                                            index={index}
                                        />
                                    </React.Fragment>
                                ))
                            }
                        </div>
                    </div>
                </div>)
            }
            </>
            <>
            {
                (currentService.sect6) &&
                (<div className="section">
                    <div className="flex flex-col gap-8 lg:gap-16">
                        <div className="flex flex-col gap-5">
                            <p className="text-3xl font-semibold text-black-1A1 lg:text-4xl">{t(currentService.sect6.title)}</p>
                            <>
                            {
                                (currentService.sect6.paragraph) &&
                                <p className="text-base font-normal text-gray-535 lg:text-xl lg:max-w-[40rem]">{t(currentService.sect6.paragraph)}</p>
                            }
                            </>
                        </div>
                        <div className="grid gap-16 lg:gap-10 lg:grid-cols-[1fr,31.25rem]">
                            <div className="grid sm:grid-cols-2">
                                {
                                    currentService.sect6.list.map((item, index: number) => (
                                        <React.Fragment key={`${serviceUrlEndpoint}-sect-5-${index}`}>
                                            <IconCardComponent
                                                img={item.img}
                                                imgContainerClass={'bg-white border border-gray-E9E'}
                                                title={item.title}
                                                titleClass={'text-black-1A1'}
                                                paragraph={item.paragraph}
                                                paragraphClass={'text-gray-535'}
                                                index={index}
                                            />
                                        </React.Fragment>
                                    ))
                                }
                            </div>
                            <div
                                className="relative bg-cover w-full h-[23.125rem] rounded-md bg-gray-DDE lg:h-full lg:rounded-lg"
                                style={{ backgroundImage: `url('${currentService.sect6.img}')`}}
                            ></div>
                        </div>
                    </div>
                </div>)
            }
            </>
            <>
            {
                (currentService.sect7) &&
                (<div className="section">
                    <div className="flex flex-col gap-8 lg:gap-16">
                        <div className="flex flex-col gap-5">
                            <p className="text-3xl font-semibold text-black-1A1 lg:text-4xl">{t(currentService.sect7.title)}</p>
                            <>
                            {
                                (currentService.sect7.paragraph) &&
                                <p className="text-base font-normal text-gray-535 lg:text-xl lg:max-w-[40rem]">{t(currentService.sect7.paragraph)}</p>
                            }
                            </>
                        </div>
                        <div className="grid gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
                            {
                                currentService.sect7.list.map((item, index: number) => (
                                    <React.Fragment key={`${serviceUrlEndpoint}-sect-5-${index}`}>
                                        <IconCardComponent
                                            classes={'text-white bg-blue-1F3'}
                                            img={item.img}
                                            imgContainerClass={'bg-light-gray-E9E text-gray-414'}
                                            title={item.title}
                                            titleClass={'text-light-gray-E9E'}
                                            paragraph={item.paragraph}
                                            paragraphClass={'text-gray-E9E'}
                                            index={index}
                                        />
                                    </React.Fragment>
                                ))
                            }
                        </div>
                    </div>
                </div>)
            }
            </>
            <>
            {
                (currentService.sect8) &&
                (<div className="section">
                    <JoinMovementComponent
                        title={ currentService.sect8.title}
                        paragraph= {currentService.sect8.paragraph || ''}
                        img={currentService.sect8.img}
                        list={currentService.sect8.list}
                        appStoreList={currentService.sect8.appStoreList}
                    />
                </div>)
            }
            </>
            <div className="bg-light-gray-E9E">
                <GetInTouchComponent/>
            </div>
        </div>
    );
};

export default ServicePage;